import { render, staticRenderFns } from "./flashexchange.vue?vue&type=template&id=a7cdb3da&scoped=true&"
import script from "./flashexchange.vue?vue&type=script&lang=js&"
export * from "./flashexchange.vue?vue&type=script&lang=js&"
import style0 from "./flashexchange.vue?vue&type=style&index=0&id=a7cdb3da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cdb3da",
  null
  
)

export default component.exports